import type { Page } from '@hello-aria/api-client'
import { toListQuery } from '@hello-aria/makalu-api-client'
import { QueryStringInput } from '@hello-aria/query-string'
import { Company, toCompany, UpdateCompany, UpdateCompanyGateway } from '../models/companyModel'
import { trackEvent } from '../utils/analyticsUtils'
import { makaluApi } from '../utils/makaluApiClient'

export const listCompanies = (query: QueryStringInput): Promise<Page<Company>> =>
    makaluApi.listPage('/companies', {
        params: { query: toListQuery({ ...query, params: { include: ['config'] } }) }
    })

export const getCompany = async (companyId: Company['id']): Promise<Company> =>
    toCompany(await makaluApi.GET('/companies/{companyId}', { params: { path: { companyId } } }))

export const updateCompany = async (payload: Partial<UpdateCompany>, companyId: Company['id']): Promise<Company> => {
    const body: Partial<UpdateCompanyGateway> = {
        name: payload.name,
        address: payload.address,
        identifier: payload.identifier
            ? { ...payload.identifier, country: payload.identifier.country, type: payload.identifier.type }
            : undefined
    }
    const company = await makaluApi.PATCH('/companies/{companyId}', { params: { path: { companyId } }, body })

    trackEvent('Update_Company')

    return company
}
